<template>
    <f7-page id="reset-password" name="reset-password" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-block>
            <div class="b fs-24 mb-md">{{$t('account-reset-password-set-new')}}</div>
            <div class="fs-14 fw-medium mb-xxl text-color-gray">
                {{$t('account-reset-password-set-new-text')}}
            </div>

            <transition name="fade">
              <f7-card
                  :title  ="alertCard.title"
                  class   ="alert alert-danger"
                  v-show  ="alertCard.show"
              >
                  <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
              </f7-card>
            </transition>
            <f7-list class="form-group" style="">

              <f7-list-input
                input-id      ="password"
                name          ="password"
                :type         ="passwordInputType"
                class         ="password"
                placeholder   =""
                @input        ="password = $event.target.value;validateInput($event.target);validateNextButton();"
                minlength     ="8"
                :label        ="$t('account-reset-password-new-pass')"
                outline
                floating-label
                required
              >
                <div class="toggle-password" @click="showHidePassword('password')" id="password-icon" toggle="#password-field" slot="content-end" style="">
                  <i class="f7-icons">eye_slash</i>
                </div>
              </f7-list-input>

              <f7-list-input
                input-id      ="password2"
                name          ="password2"
                :type         ="password2InputType"
                class         ="password"
                placeholder   =""
                @input        ="password2 = $event.target.value;validateInput($event.target);validateNextButton();"
                minlength     ="8"
                :label        ="$t('account-reset-password-new-pass-confirm')"
                outline
                floating-label
                required
              >
                <div class="toggle-password" @click="showHidePassword('password2')" id="password-icon2" toggle="#password-field2" slot="content-end" style="">
                  <i class="f7-icons">eye_slash</i>
                </div>
              </f7-list-input>
            </f7-list>

            <f7-button large fill @click="goToNextPage" class="mt-5 view-desktop" :disabled="!isNextButtonValid">
                {{$t('account-reset-password')}}
            </f7-button>
        </f7-block>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button large fill @click="goToNextPage" :disabled="!isNextButtonValid">
                {{$t('account-reset-password')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { check } from '@/plugins/helper';
    import store from '../../store'

    export default {
        mounted (){
            this.determineAppBranchId(this.$f7.device.desktop)
            //console.log("rbId = "+store.state.misc.appBranchId)
            this.routerTo = "reset-password"

            const resetPasswordIdParam = this.$f7route.query['id'];
            const resetPasswordFpvcParam  = this.$f7route.query['fpvc'];

            if((resetPasswordIdParam && resetPasswordIdParam.trim() != "") && (resetPasswordFpvcParam && resetPasswordFpvcParam.trim() != "" )){
                //console.log("id: "+resetPasswordIdParam+" # fpvc: "+resetPasswordFpvcParam)
                this.resetPasswordId = resetPasswordIdParam;
                this.resetPasswordFpvc = resetPasswordFpvcParam;

                this.setResetPasswordId(resetPasswordIdParam);
                this.setResetPasswordFpvc(resetPasswordFpvcParam);
            }else{
                console.log("id or fpvc invalid")
            }
        },
        data() {
            return {
                isNextButtonValid       : false,
                password                : "",
                password2               : "",
                passwordInputType       : "password",
                password2InputType      : "password",
                isPasswordValid         : false,
                isPassword2Valid        : false,
                routerTo                : "",
                resetPasswordId         : 0,
                resetPasswordFpvc       : "",
                alertCard: {
                    show   : false,
                    title  : "",
                    content: ""
                },
            }
        },
        methods: {
            ...mapActions('customer', ['setResetPasswordId','setResetPasswordFpvc','setNewPassword']),
            ...mapActions('misc', ['determineAppBranchId']),

            afterin(){
              window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            showHidePassword(el){
                let $$ = this.Dom7;

                if(el == "password"){
                  if(this.passwordInputType == "password"){
                    this.passwordInputType = "text";
                    $$("#password-icon").html('<i class="f7-icons">eye</i>');
                  }else{
                    this.passwordInputType = "password";
                    $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
                  }

                } else if(el == "password2"){
                  if(this.password2InputType == "password"){
                    this.password2InputType = "text";
                    $$("#password-icon2").html('<i class="f7-icons">eye</i>');
                  }else{
                    this.password2InputType = "password";
                    $$("#password-icon2").html('<i class="f7-icons">eye_slash</i>');
                  }
                }
            },

            validateInput(e) {
                var inputName   = e.name;
                var inputValue  = "";
                var keyName     = "regis-"+e.name;
                var translation;

                if(e.name == "password"){
                  inputValue = this.password;
                }else{
                  inputValue = this.password2;
                }

                if (inputValue == ""){
                  translation = keyName + "-empty";
                  this.setInputState(inputName, this.$t(translation));
                  return false;
                }

                var validate = false;
                if(inputName == "password" || inputName == "password2"){
                  validate   = check.validPattern("password", e.value);
                }
                //console.log("VALIDATE # "+e.name+" : "+validate);

                if(!validate){
                  translation = keyName + "-rule";
                  this.setInputState(inputName, this.$t(translation));
                  if(inputName == "password"){
                    this.isPasswordValid = false;
                  }else if(inputName == "password2"){
                    this.isPassword2Valid = false;
                  }
                  this.isNextButtonValid = false;
                  return false;
                }

                if(inputName == "password"){
                  this.isPasswordValid = true;
                }else if(inputName == "password2"){
                  this.isPassword2Valid = true;
                }


                if (inputName == "password"){
                    if(this.password2.trim() != ""){
                        if( this.password != this.password2){
                            translation = "regis-password2-mismatch";
                            this.setInputState("password2", this.$t(translation));
                            this.isPassword2Valid = false;
                            this.isNextButtonValid = false;

                            if(validate){
                                this.isPasswordValid = true;
                                this.setInputState("password", true);
                            }
                            return false;
                          }else{
                            this.isPasswordValid = true;
                            this.isPassword2Valid = true;
                            this.setInputState("password", true);
                            this.setInputState("password2", true);
                          }
                    }
                }

                if (inputName == "password2"){
                  if( this.password != this.password2){
                    translation = keyName + "-mismatch";
                    this.setInputState("password2", this.$t(translation));
                    this.isPasswordValid = false;
                    this.isPassword2Valid = false;
                    this.isNextButtonValid = false;
                    return false;
                  }else{
                    this.isPasswordValid = true;
                    this.isPassword2Valid = true;
                  }
                }

                this.setInputState(inputName, true);
                return true;
            },

            validateNextButton(){
                this.isNextButtonValid = this.isPasswordValid && this.isPassword2Valid;
            },

            async goToNextPage(){
                this.showPreloader();
                if(this.isPasswordValid && this.isPassword2Valid){
                    //console.log("new password: "+this.password)
                    this.setNewPassword(this.password);

                    const verifyForgotPassword = await this.$api.customer.verifyForgotPassword();
                    //console.log("verifyForgotPassword: ", verifyForgotPassword);

                    var resetPassOTP = store.state.misc;
                    if(verifyForgotPassword.status == "WN00133"){ // success
                        resetPassOTP.otp.routerTo = 'resetPasswordComplete';

                        const requestOtp    = await this.$api.otp.requestotp(7);
                        if(requestOtp.status){
                            this.$f7router.navigate("/otp");
                            this.hidePreloader();
                        }else{
                            this.showAlert(true, requestOtp.message)
                            this.hidePreloader();
                        }


                    }else if(verifyForgotPassword.status == "0305"){
                      this.showAlert(true, verifyForgotPassword.message);
                      this.hidePreloader();
                    }else{ // failed
                        console.log("verify forgot password failed : "+ verifyForgotPassword.status)
                        this.hidePreloader();
                    }
                }
            },

            showAlert(status, title, content){
                this.alertCard.show = status;
                if (title == undefined){
                  title = "";
                }
                if (content == undefined){
                  content = "";
                }
                this.alertCard.title= title;
                this.alertCard.content = content;

            },

            backButton() {
                // NOTE: 19/04/2023 To view this reset password screen can only by reset password link sent to customer email for currently flow.
                this.$f7router.back("/login", {force:true})
            }
        },
        computed: {
            ...mapGetters('customer', [

            ])
        }
    }
</script>